import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { RFIDCardProtocol, RFIDCardProtocolEntry } from '../model/rfid-card-protocol.model';
import { Component, OnInit } from '@angular/core';
import { ResponseMessage, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';

@Component({
  selector: 'app-rfid-card-protocol',
  templateUrl: './rfid-card-protocol.component.html',
  styleUrls: ['./rfid-card-protocol.component.scss']
})
export class RFIDCardProtocolComponent extends AbstractWidgetComponent implements OnInit {

  columnsToDisplay = ['usageTimestamp', 'usageLocation', 'rfidCardNumber', 'rfidCardDescription', 'accessAllowed', 'filler'];

  responseMessages: ResponseMessage[];
  isLoading = false;

  rfidCardProtocol: RFIDCardProtocol;

  dataSource = new MatTableDataSource(new Array<RFIDCardProtocolEntry>());


  constructor(
    private appServerAPI: AppServerAPI,
    ) {
    super();
  }

  ngOnInit() {
    this.load();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  private load() {
    this.isLoading = true;
    this.responseMessages = [];
    this.appServerAPI.execute<RFIDCardProtocol>('/client/admin/rfidcardprotocol', {}).subscribe(rfidProtocol => {
      this.rfidCardProtocol = new RFIDCardProtocol(rfidProtocol);
      this.buildTableDataSource();
      this.isLoading = false;
    }, error => {
      console.error(error);
      this.isLoading = false;
    });
  }

  private buildTableDataSource() {
    const data = new Array<RFIDCardProtocolEntry>();
    if (this.rfidCardProtocol.protocolEntries != null) {
      data.push(...this.rfidCardProtocol.protocolEntries);
    }
    this.dataSource = new MatTableDataSource(data);
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
